// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__EB9UF","container":"styles_container__1SkAf","title":"styles_title__2QeMM","wrapper":"styles_wrapper__9_mrH","answer":"styles_answer__TqSFn"};